import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Spend_Function_Search_Fields: {[id:string]: ISearchProviderField} = {
    WB_SPEND_FUNCTION_ID:         {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB Spend Function Id',       columnResourceName: 'colId',              alignment: HorizAlignment.Left},  domainOptions: {}},
    SPEND_FUNCTION_NAME:          {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Spend Function Name',        columnResourceName: 'colName',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    SPEND_FUNCTION_ID:            {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Spend Function Id',          columnResourceName: 'colPId',          alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CALCULATION_DISPLAY:          {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Calculation Display',        columnResourceName: 'colType',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    FUNCTION_DEFN_SRC:            {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Java Defn',                  columnResourceName: 'colType',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    MANUAL_IND:                   {type: SearchProviderFieldType.boolean,  renderOptions: { columnName: 'Manual',        columnResourceName: 'colType',        alignment: HorizAlignment.Left},  domainOptions: {}},
    FUNCTION_TYPE:                {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Type',        columnResourceName: 'colType',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50, domainIds: 'FunctionType', useIdAsKey: true}},
    FUNCTION_SUBTYPE:             {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Sub Type',        columnResourceName: 'colType',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50, domainIds: 'FunctionSubType', useIdAsKey: true}},
    FUNCTION_USAGE:               {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Usage',        columnResourceName: 'colType',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50, domainIds: 'FunctionUsage', useIdAsKey: true}},
    PROFILE_DEFAULT_IND:          {type: SearchProviderFieldType.boolean,  renderOptions: { columnName: 'Profile Default',        columnResourceName: 'colType',        alignment: HorizAlignment.Left},  domainOptions: {}},
    SPEND_FUNCTION_NAME_SPECIFIC: {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Specific Function Name',        columnResourceName: 'colName',        alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    SPEND_FUNCTION_ID_SPECIFIC:   {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Specific Function Id',          columnResourceName: 'colPId',          alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
};

const SpendFunctionSearchBasic: ISearchProvider = {

    keyFields: {id: 'WB_SPEND_FUNCTION_ID',
        id_ui: 'SPEND_FUNCTION_ID',
        name: 'SPEND_FUNCTION_NAME'

    },

    searchProviderFields: vUI_Spend_Function_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Spend_Function_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res:any)=>{
                    resolve(res)
                })
                .catch((err)=>{
                    error(err)
                })
        })
    }
};

const SpendFunctionSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "SpendFunctionSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'SPEND_FUNCTION_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'SPEND_FUNCTION_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'SPEND_FUNCTION_NAME', 'SPEND_FUNCTION_ID', 'CALCULATION_DISPLAY',
        'FUNCTION_TYPE','FUNCTION_SUBTYPE','FUNCTION_USAGE', 'SPEND_FUNCTION_NAME_SPECIFIC',
        'CREATED_DTTS', 'MODIFIED_DTTS', 'PROFILE_DEFAULT_IND','MANUAL_IND'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: SpendFunctionSearchBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const SpendFunctionSearch: ISearch = {
    searchName: "Find Spend Function",
    renderOptions: {ui5ResourceId: "SpendFunctionSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [SpendFunctionSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("SpendFunctionBO", "SpendFunction", SpendFunctionSearch, "Spend Function Search")

export {SpendFunctionSearch}
